module.exports = new __parcel__URL__("market_size_and_performance.fd9c2e5e.svg").toString();